// Polyfills for browser environment
// 确保 Buffer 在全局作用域中可用
if (typeof window !== 'undefined') {
  // 创建一个简单的 Buffer polyfill
  (window as any).Buffer = {
    from: function (data: any) {
      if (typeof data === 'string') {
        return new TextEncoder().encode(data);
      }
      return data;
    },
    isBuffer: function (obj: any) {
      return obj instanceof ArrayBuffer || obj instanceof Uint8Array;
    },
  };
  (window as any).global = window;
}
